import { render } from "./Home.vue?vue&type=template&id=8f3cf13e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8f3cf13e&lang=css"

import exportComponent from "/home/darnell/Development/accounting/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__